import { useIntl } from 'react-intl';

import { useClinicTreatments } from './useClinicTreatments';

const treatmentTypesMap: Record<string, string> = {
  'Allurion Balloon Program': '1',
  'Weight Doctors BARIATRICS® Gastric Bypass': '2',
  'Weight Doctors BARIATRICS® Gastric Sleeve': '3',
  'Weight Doctors SLEEVE® OverStitch': '4',
  'Weight Doctors SLEEVE® pose2': '5',
  'Gastric Balloon for 12 months': '6',
  'Gastric Balloon for 6 months': '7',
  'Medication Therapy': '8',
  'Nutricare 3 months': '10',
  'Nutricare 6 months': '11',
  'Nutricare 12 months': '12',
  'Allurion Balloon Program 6 months': '13',
  'Allurion Balloon Program 12 months': '14',
  'Allurion Balloon Program 18 months': '15',
};

export function useTreatmentLabels(clinicID?: string) {
  const intl = useIntl();
  const { treatmentList } = useClinicTreatments(clinicID);

  return {
    getTreatmentCategoryLabel(treatmentCategoryId: number | string, type?: string) {
      const translationKeyId = `treatment-category${type === 'short' ? '-short' : ''}-name-${treatmentCategoryId}`;

      return intl.formatMessage({
        id: translationKeyId,
      });
    },
    getTreatmentCategoryLabelByTreatmentId(treatmentId: number | string, type?: string) {
      const treatmentType = treatmentList.find(
        ({ custom_treatment_id }) => custom_treatment_id === treatmentId.toString()
      );

      if (!treatmentType) {
        return '';
      }

      const translationKeyId = `treatment-category${type === 'short' ? '-short' : ''}-name-${treatmentType.treatment_type_id}`;

      return intl.formatMessage({
        id: translationKeyId,
      });
    },
    getTreatmentLabel(treatmentTypeId: number | string, type?: string) {
      const treatmentType = treatmentList.find(
        ({ custom_treatment_id }) => custom_treatment_id === `${treatmentTypeId}`
      );

      if (!treatmentType || Number(treatmentTypeId) < 100) {
        const translationKeyId = `treatment${type === 'short' ? '-short' : ''}-name-${treatmentTypeId}`;

        return intl.formatMessage({
          id: translationKeyId,
        });
      }

      const keyName = type === 'short' ? 'custom_treatment_short_name' : 'custom_treatment_name';

      const translationKeySize = type === 'short' ? 'short' : 'long';

      const translationKeyId = `treatment_type_custom_${
        treatmentTypesMap[treatmentType.custom_treatment_name]
      }_${translationKeySize}`;

      const label = intl.formatMessage({
        id: translationKeyId,
        defaultMessage: treatmentType?.[keyName],
      });

      return label;
    },
  };
}
